import type { RouteLocationRaw } from 'vue-router';

/**
 * Route guard for the /sparnatural page.
 * Redirects to /api when the "latest" feature flag is disabled.
 * The latest flag accepts boolean true or case-insensitive string "true".
 */
export function sparnaturalRouteGuard(latest: boolean | string | undefined): boolean | RouteLocationRaw {
  const enabled = latest === true || (typeof latest === 'string' && latest.toLowerCase() === 'true');
  return enabled ? true : { path: '/api' };
}
